


import React, { useState } from "react";
import { Link } from "react-router-dom";
import Ratings from "./Ratings";

function Foodratings() {
    const isMobile = window.innerWidth <= 768;
    const [activeTab, setActiveTab] = useState("Reviews & Ratings");

    // Tab content configuration
    const tabContent = {
        "Reviews & Ratings": <Ratings />,
        "Response Management": <div>Response Management Content</div>,
    };

    return (
        <>
            <style>{`
        .main-container {
          padding: 20px;
          display: flex;
          flex-direction: column;
        }

        .tabs-wrapper {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 0px;
          margin-left: 0px;
        }

        @media screen and (max-width: 768px) {
          .tabs-wrapper {
            margin-left: 0;
          }
        }

        .tab-bbuttons {
          display: flex;
          justify-content: center;
          gap: 10px;
          margin-top: 0px;
          padding: 14px;
        }

        .tab-button {
          border: none;
          border-radius: 10px;
          // width: 180px;
          // height: 40px;
          background-color: #d9d9d9;
          color: #000;
          font-weight: 500;
          cursor: pointer;
          transition: background-color 0.3s ease;
          font-size: 16px;
          white-space: nowrap;
          padding:10px 20px;
        }

        .tab-button.active {
          color: white;
          background-color: #b15cd6;
        }

        .tab-content {
          margin-top: 0px;
          width: 100%;
          overflow-x: auto;
          overflow-y: scroll;
        }

        .tab-content::-webkit-scrollbar {
          width: 1px;
          height: 8px;
        }

        .tab-content::-webkit-scrollbar-track {
          background: #f0f0f0;
        }

        .tab-content::-webkit-scrollbar-thumb {
          background: #b15cd6;
          border-radius: 10px;
        }

        .tab-content {
          scrollbar-width: none;
        }

        @media (max-width: 500px) {
          .tab-button {
            width: 160px !important;
            font-size: 13px;
          }
        }

        @media (max-width: 400px) {
          .tab-button {
            width: 140px !important;
            font-size: 12px;
          }
        }
      `}</style>

            <div className="container-fluid company-mobile-data"
                style={{
                    height: "500px"
                }}
            >
                <div className="row">
                    {/* Left Column - Empty */}
                    <div className="col-lg-2">
                        {/* Left section completely empty as requested */}
                    </div>

                    {/* Middle Column - Main Content */}
                    <div className="col-lg-8">
                        {/* Breadcrumb */}
                        <p
                            className="breadcrumb maamaas-home-bredcum"
                            style={{
                                position: "fixed",
                                top: window.innerWidth <= 425 ? "50px" : window.innerWidth > 425 && window.innerWidth <= 768 ? "55px" : "64px",
                                left: "2vw",
                                width: "100%",
                                backgroundColor: "#fff",
                                zIndex: 1000,
                                padding: "10px 0",
                                fontSize: isMobile ? "16px" : "18px",
                                fontWeight: isMobile ? "normal" : "bold",
                                textAlign: "center",
                                margin: 0,
                            }}
                        >
                            <Link
                                to="/foodladingpage"
                                style={{
                                    color: "purple",
                                    fontWeight: "bold",
                                    textDecoration: "none",
                                }}
                            >
                                Food & Beverages
                            </Link>
                            <span className="separator"> &gt; </span>
                            <Link
                                style={{
                                    color: "purple",
                                    fontWeight: "bold",
                                    textDecoration: "none",
                                }}
                            >
                                Ratings & Reviews
                            </Link>
                        </p>

                        {/* Main Content Container */}
                        <div style={{
                            marginTop: window.innerWidth < 768 ? "40px" : "00px",
                            padding: isMobile ? "0px" : "20px",
                            backgroundColor: "#fff",
                            borderRadius: "10px",
                            width: window.innerWidth < 700 ? "90vw" : "auto",
                        }}>
                            {/* Tabs Wrapper */}
                            <div className="tabs-wrapper">
                                {/* Tab Buttons - Matching your Foodbeveragescompany structure */}
                                <div className="tab-bbuttons" style={{ 
                                    flexWrap: window.innerWidth <= 562 ? "wrap" : "nowrap", 
                                    marginTop:window.innerWidth<769 ?  "0px" : "40px", 
                                }}>
                                    {Object.keys(tabContent).map((label) => (
                                        <button
                                            key={label}
                                            className={`tab-button ${activeTab === label ? "active" : ""}`}
                                            onClick={() => setActiveTab(label)}
                                        >
                                            {label}
                                        </button>
                                    ))}
                                </div>
                                
                                {/* Tab Content */}
                                <div
                                    className="tab-content"
                                    style={{
                                        height:window.innerWidth<500 ? "80vh": "65vh",
                                        overflowX: "auto",
                                        overflowY: "scroll",
                                        width: window.innerWidth < 400 ? "90vw" : window.innerWidth < 450 ? "90vw" : "auto",
                                        padding: "10px",
                                        backgroundColor: "#fff",
                                        borderRadius: "8px",
                                    }}
                                >
                                    {tabContent[activeTab]}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Right Column - Empty */}
                    <div className="col-lg-2">
                        {/* Right section completely empty as requested */}
                    </div>
                </div>
            </div>
        </>
    );
}

export default Foodratings;